<template>
  <div
    class="swiper-navigation"
    :class="[
      $blockClass(blockClass, 'navigation')
    ]"
  >
    <div
      class="
        swiper-navigation__dots
        swiper-pagination-clickable
        swiper-pagination-bullets
        swiper-pagination-horizontal
      "
      :class="[
        `swiper-pagination-${sectionId}`,
        $blockClass(blockClass, 'navigation-dots')
      ]"
    />

    <button
      :aria-label="'Next slide'"
      class="swiper-navigation__arrow"
      :class="[
        `swiper-button-next-${sectionId}`,
        $blockClass(blockClass, 'arrow')
      ]"
    >
      <icon-arrow-right />
    </button>
  </div>
</template>

<script>

/**
 * Vue: Swiper navigation (swiper-navigation)
 * -----------------------------------------------------------------------------
 * Component swiper navigation.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 */
import IconArrowRight from '~icons/direction/arrow/right.svg'
export default {
  name: 'SwiperNavigation',

  components: {
    IconArrowRight,
  },

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    sectionId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {

    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>

<style lang="scss">
@import './swiper-navigation';
</style>
